import { Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, PageSection } from 'Components/Layout';
import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';

let FinePortionSubspecimenDryMassesSection: React.FC<IWorksheetComponent> = () => {
  return (
    <PageSection heading="Fine Portion Subspecimen">
      <NamePrefixModifier>
        <ListFieldSection>
          <WorksheetBalanceFieldSet
            name="Subspecimen.Masses.MassMeasurement.Equipment.DryMassBalance"
            copyTo={['Equipment.Balance']}
          />
          <Field input={<NumericInput />} name="Masses.DryMassCombinedWithSeparationLosses" />
          <Field input={<TextOutput />} name="Masses.ExpectedDryMassCombinedWithSeparationLosses" />
          <Field
            input={<NumericInput />}
            name="Subspecimen.Masses.MassMeasurement.TareAndDryMass" // we use TareAndDryMass to record Dry Mass with zero tare mass
            label="Subspecimen Dry Mass"
            additionalMessagePaths={['Subspecimen.Masses.DryMass']} //display messages from Dry Mass when we use the TareAndDryMass to record DryMass
          />
        </ListFieldSection>
      </NamePrefixModifier>
    </PageSection>
  );
};

FinePortionSubspecimenDryMassesSection = withInjectedProps(FinePortionSubspecimenDryMassesSection);

export { FinePortionSubspecimenDryMassesSection };
export default FinePortionSubspecimenDryMassesSection;
